export const SELECTED_BRAND: string = 'SELECTED_BRAND'
